import React from 'react';

import { getBooleanFF } from '@atlaskit/platform-feature-flags';

import { type Heartbeat } from '../../types';
import { OffStatus, PendingStatus, ResponsiveStatus, UnresponsiveStatus } from '../status-labels';

export const HeartbeatStatus: React.FC<{
	heartbeat: Heartbeat;
	isTransitioning?: boolean;
}> = ({ heartbeat, isTransitioning }) => {
	const { status } = heartbeat;
	const showOptimalTooling = isTransitioning && getBooleanFF('platform.show-optimal-tooling_brgom');

	switch (status) {
		case 'Pending':
			return <PendingStatus showOptimalTooling={showOptimalTooling} />;
		case 'Responsive':
			return <ResponsiveStatus showOptimalTooling={showOptimalTooling} />;
		case 'Unresponsive':
			return <UnresponsiveStatus showOptimalTooling={showOptimalTooling} />;
		case 'Off':
			return <OffStatus showOptimalTooling={showOptimalTooling} />;
		default:
			return null;
	}
};
